import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { courseActions } from '../actions/course.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class CourseEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getCourses$ = createEffect(() => {
        return this.actions.pipe(
            ofType(courseActions.getCourse),
            mergeMap(({ id }) => {
                return this.httpService.getCourse(id).pipe(
                    // finalizeLoader('library-get-course'), // FIXME: Silent loader required, that does not show up in the UI
                    map((course) => courseActions.getCourseSuccess({ course })),
                    catchError(() => of(courseActions.getCourseError({ id }))),
                );
            }),
        );
    });
}
